import { type SettingsCompany } from '../hooks/getSettings';

export const getSettingLoyaltyProgramUrl = (shopUrl: SettingsCompany['companyShopUrl']) => `${shopUrl}/loyalty-program`;
